import FeatureDiscoveryStore from "../../../client-store/featureDiscovery.store.js";
import { SDB_TEMPLATE_TOUR_ID } from "../../../feature-discovery/constants/tours.consts.js";
export const featureDiscoveryStore = new FeatureDiscoveryStore(SDB_TEMPLATE_TOUR_ID);
export default featureDiscoveryStore;
